import React, { useState } from 'react';
import { getApiUrl } from '../utils/apiConfig';
import { auth } from '../services/firebase'; // Importa a autenticação do Firebase
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/Login.module.css';

import {
  Container, Box, Paper, Typography, TextField, Button, Link,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState({ title: '', message: '' });

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Faz o login usando o Firebase
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Pega o ID token do usuário
      const token = await user.getIdToken();

      // Armazena o token no localStorage (opcional, mas útil para o backend)
      localStorage.setItem('token', token);


      // ... (inside handleLogin)

      // ... (inside handleLogin)
      // Envia o token para o backend para obter o papel do usuário
      const response = await fetch(`${getApiUrl()}/api/user-role`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        if (response.status === 403 && errorData.error) {
          // Handle Suspension or Permission Error with Popup
          setDialogContent({
            title: errorData.isSuspended ? 'Acesso Suspenso' : 'Acesso Negado',
            message: errorData.error
          });
          setOpenDialog(true);
          // Sign out from Firebase so they are not "half-logged"
          await auth.signOut();
          return;
        }
        throw new Error('Erro ao obter papel do usuário');
      }

      const { role } = await response.json();

      // Redireciona o usuário com base no papel
      if (['sindico', 'sub_sindico', 'conselheiro', 'morador', 'zelador'].includes(role)) {
        navigate('/dashboard');
      } else if (role === 'funcionario') {
        navigate('/controle-ponto');
      } else if (role === 'admin_sistema') {
        navigate('/gerenciar-condominios');
      } else if (role === 'administradora') {
        navigate('/controle-estoque');
      }
    } catch (error) {
      // Trata erros de login do Firebase e do backend
      // Se for erro de auth do firebase (ex: senha errada), mostramos alert ou dialog também? 
      // Manter alert para erros genéricos por enquanto, ou usar dialog?
      // Vamos usar alert simples para o resto para não complicar demais o diff
      console.error(error);
      alert('Erro ao fazer login: ' + (error.message || error));
    }
  };

  return (
    <Container
      component="main"
      maxWidth={false}
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(45deg, #283593 30%, #1976d2 90%)', // Fundo gradiente azul
      }}
    >
      <Paper
        elevation={12}
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '400px',
          width: '100%',
          borderRadius: '16px',
          // Efeito "glassmorphism" para um visual moderno
          backgroundColor: 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
        }}
      >
        <Typography component="h1" variant="h4" sx={{ color: 'white', fontWeight: 'bold', mb: 3 }}>
          Predioo Login
        </Typography>
        <Box component="form" onSubmit={handleLogin} sx={{ mt: 1, width: '100%' }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Endereço de Email"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, py: 1.5, borderRadius: '8px' }}
          >
            Entrar
          </Button>
          <Typography variant="body2" align="center" sx={{ color: 'white' }}>
            Não tem uma conta?{' '}
            <Link href="/cadastro" variant="body2" sx={{ color: 'lightblue', fontWeight: 'bold' }}>
              {"Cadastre-se"}
            </Link>
          </Typography>
        </Box>
      </Paper>

      {/* Dialog para mensagens de erro/suspensão */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {dialogContent.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogContent.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} autoFocus>
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Login;